import React from 'react';

interface PercentageInfoProps {
  totalSize: number;
  resultsCount: number;
}

export const PercentageInfo: React.FC<PercentageInfoProps> = ({
  totalSize,
  resultsCount,
}) => {
  return (
    <div className="percentage-info">
      <div className="percentage-description">{`Du har sett ${totalSize} av ${resultsCount} saker`}</div>
      <div className="progress-bar-container">
        <div
          className="progress-bar"
          style={{
            width: `${~~((totalSize / resultsCount) * 100)}%`,
          }}
        ></div>
      </div>
    </div>
  );
};
